import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalInputImageUploadComponent } from '@app/shared/components/modal-input-image-upload/modal-input-image-upload.component';
import { IImageDescription } from '../../models/image-description.interface';
import Utils from '@app/shared/utils/utils';
import { ActivatedRoute } from '@angular/router';
import { Convert } from '@app/shared/utils/ConvertMimeTypes';

@Component({
  selector: 'app-divergence-file-upload',
  templateUrl: './divergence-file-upload.component.html',
  styleUrls: ['./divergence-file-upload.component.sass'],
})
export class DivergenceFileUploadComponent {
  @Input() idTrade: string = '';
  @Input() evidences: IImageDescription[] = [];
  @Input() useWebcam: boolean = false;
  @Output() filesChanged = new EventEmitter<IImageDescription[]>();

  token: string = '';

  constructor(private _dialog: MatDialog, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.token = params['token'];
    });
  }

  updateDefaultImage(description: string) {
    const image = this.evidences.find((img) => img.description === description);

    if (this.useWebcam) {
      this.openWebcam((result: string) => {
        image.src = result;
        this.filesChanged.emit(this.evidences);
      });
    } else {
      const dialogRef = this._dialog.open(ModalInputImageUploadComponent, {
        panelClass: 'custom-dialog-container',
        data: {
          idTrade: this.idTrade,
          model: 'ips',
          evidences: this.evidences,
          smartUp: true,
          token: this.token,
        },
      });

      dialogRef.afterClosed().subscribe((result: string | boolean) => {
        if (typeof result === 'string') {
          image.src = result;
          this.filesChanged.emit(this.evidences);
        }
      });
    }
  }

  getExtraImage() {
    const dialogRef = this._dialog.open(ModalInputImageUploadComponent, {
      panelClass: 'custom-dialog-container',
      data: { idTrade: this.idTrade, model: 'ips', evidences: this.evidences },
    });

    dialogRef.afterClosed().subscribe((result: string | boolean) => {
      if (typeof result === 'string') {
        const description = this._getRandomDescription(result);
        const image = {
          src: result,
          description,
          isExtra: true,
        };
        this.evidences.push(image);
        this.filesChanged.emit(this.evidences);
      }
    });
  }

  private _getRandomDescription(image: string): string {
    const mimeType = image.match(/[^:]\w+\/[\w-+\d.]+(?=;|,)/)[0];
    return Utils.randomFilenameGenerator('evidencia_extra', Convert.getExtension(mimeType)[0]);
  }

  removePhotoBy(description: string) {
    this.evidences = this.evidences.filter((img) => img.description !== description);
    this.filesChanged.emit(this.evidences);
  }

  updateImageDescription(description: string, image: IImageDescription) {
    image.description = description;
    this.filesChanged.emit(this.evidences);
  }

  clearDefaultImage(description: string) {
    const image = this.evidences.find((img) => img.description === description);
    image.src = '';
    this.filesChanged.emit(this.evidences);
  }

  extraEvidencesList() {
    return this.evidences.filter((img) => img.isExtra);
  }

  getDefaultImageList() {
    return this.evidences.filter((img) => !img.isExtra);
  }

  private openWebcam(callback: (result: string) => void) {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.style.display = 'none';
    fileInput.onchange = (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target.files && target.files[0]) {
        const file = target.files[0];
        const reader = new FileReader();
        reader.onload = () => callback(reader.result as string);
        reader.readAsDataURL(file);
      }
    };
    document.body.appendChild(fileInput);
    fileInput.click();
    document.body.removeChild(fileInput);
  }

  fileUp(event: Event) {
    const target = event.target as HTMLInputElement;
    const file = target.files[0];

    const filename = `${this.idTrade}/${Utils.randomFilenameGenerator(
      'laudo',
      Convert.getExtension(file.type)[0]
    )}`;
  }
}
